import React from 'react';

import Drawer from '@mui/material/Drawer';

import { useTranslation } from "react-i18next";

import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import MultiCheckBox from '../MultiCheckBox';


const TrendsDrawer = (props) => {

  const [t] = useTranslation('common');
  const { i18n } = useTranslation('home');

  let list = () => (
    <div
      style={{ width: "350px" }}
      role="presentation"
    >
      <h2 className="pt-2 pb-2 text-center">{t('compareperiods.filters')}</h2>

      <div className="overflow-y-scroll pt-1 ps-2" style={{ maxHeight: "90vh" }}>

        <h3 className="pt-4">{t('trends.days')}</h3>
        <div className="col pb-3">
          <div type="button" className={props.service == "tous" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handleDayTypeClick(e, props.t, props.setService, props.setRecalcAvg)} >{t('compareperiods.all')}</div>
          <div type="button" className={props.service == "se" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handleDayTypeClick(e, props.t, props.setService, props.setRecalcAvg)} >{t('compareperiods.week')}</div>
          <div type="button" className={props.service == "fds" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handleDayTypeClick(e, props.t, props.setService, props.setRecalcAvg)} >{t('compareperiods.weekends')}</div>
        </div>

        <h3 className="pt-3">{t('trends.period')}</h3>
        <div className="col pb-3">
          <div type="button" className={props.period == "all" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handlePeriodClick(e, props.t, props.setPeriod, props.setRecalcAvg)}>{t('compareperiods.all')}</div>
          <div type="button" className={props.period == "morning" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handlePeriodClick(e, props.t, props.setPeriod, props.setRecalcAvg)}>{t('compareperiods.morning')}</div>
          <div type="button" className={props.period == "am" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handlePeriodClick(e, props.t, props.setPeriod, props.setRecalcAvg)}>{t('compareperiods.am')}</div>
          <div type="button" className={props.period == "op" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handlePeriodClick(e, props.t, props.setPeriod, props.setRecalcAvg)}>{t('compareperiods.offpeak')}</div>
          <div type="button" className={props.period == "pm" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handlePeriodClick(e, props.t, props.setPeriod, props.setRecalcAvg)}>{t('compareperiods.pm')}</div>
          <div type="button" className={props.period == "evening" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handlePeriodClick(e, props.t, props.setPeriod, props.setRecalcAvg)}>{t('compareperiods.evening')}</div>
        </div>

        <div className="row pt-3 pb-3">
          <h3>{t('datatable.routes')}</h3>
          <MultiCheckBox
            options={props.routes.map((e) => e.route_id)}
            handleMultiRoutes={props.handleMultiRoutes}
            selectedRoutes={props.selectedRoutes}
            setSelectedRoutes={props.setSelectedRoutes}
            setRecalcAvg={props.setRecalcAvg}
          />
        </div>

        {props.error == true ?
          <Stack className="pt-2 pb-2" sx={{ width: '100%' }} spacing={2}>
            <Alert severity="error">{t('compareperiods.alert')}</Alert>
          </Stack>
          : ''}

        <div className="text-center pt-3 pb-3">
          <div type="button" className="btn btn-primary me-1" onClick={props.handleFilters} >{t('compareperiods.apply')}</div>
        </div>

      </div>

    </div>

  );

  return (
    <Drawer anchor={'left'} open={props.open} onClose={props.toggle}>
      {list('left')}
    </Drawer>
  )

}

export default TrendsDrawer;